"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFieldLogic = void 0;
const clipboard_1 = require("../../clipboard/clipboard");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const google_sheet_1 = require("../../utils/google-sheet");
const date_1 = require("../../formatters/mixins/date");
const time_1 = require("../../formatters/time");
const intl_1 = require("../../locale/intl");
const time_fieldtype_1 = require("../../safe-field-value/date-fields/time-field/time.fieldtype");
const texts_1 = require("../../texts");
const validation_1 = require("../../validation/validation");
class TimeFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.icon = "clock";
        this.iconColor = "#3A86FF";
        this.name = "timefield";
        this.label = (0, intl_1.$t)(texts_1.timeFieldText.time);
        this.placeholder = (0, intl_1.$t)(texts_1.timeFieldText.enter_time_here);
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.timeFieldText.hh)];
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_equal_to: comparisons_1.isEqualTime,
            is_not_equal_to: comparisons_1.isNotEqualTime,
            is_greater_than: comparisons_1.isAfterTime,
            is_less_than: comparisons_1.isBeforeTime,
            is_equal_or_greater_than: comparisons_1.isEqualOrAfterTime,
            is_equal_or_less_than: comparisons_1.isEqualOrBeforeTime,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
        };
        this.fieldValueGetter = new time_fieldtype_1.TimeFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            timefield: clipboard_1.clipboardTimeToSelf,
            textfield: clipboard_1.clipboardTextToTime,
            recordtitlefield: clipboard_1.clipboardTextToTime,
            textareafield: clipboard_1.clipboardTextToTime,
            richtextareafield: clipboard_1.clipboardTextToTime,
            unknownfield: clipboard_1.clipboardTextToTime,
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return { required: validation_1.required, unique: uniqueValidator };
    }
    getEmptyValue() {
        return null;
    }
    getInitialFieldValue(startValue) {
        return startValue || this.getEmptyValue();
    }
    valueToString(fieldValue, field, userPreferences) {
        var _a, _b;
        if (!fieldValue) {
            return "";
        }
        return new time_1.TimeFormatter().transform(fieldValue, (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.time_format, (_b = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.language) === null || _b === void 0 ? void 0 : _b.value);
    }
    valueToGoogleSheet(fieldValue, field, userPreferences) {
        if (!fieldValue) {
            return super.valueToGoogleSheet(fieldValue, field, userPreferences);
        }
        const exportValue = this.valueToExport(fieldValue, field, userPreferences);
        const timeFormat = userPreferences.locale.time_format === "24h" ? "hh:mm" : "hh:mm am/pm";
        const dateMixin = new date_1.DateFormatterMixin();
        const time = typeof exportValue === "string"
            ? dateMixin.getTime(exportValue, dateMixin.extractTimeFormat(exportValue))
            : exportValue;
        const timeString = time.format("HH:mm:ss");
        const value = `=TIMEVALUE("${timeString}")`;
        return (0, google_sheet_1.makeRowDataValues)(value, "formulaValue", "DATE", timeFormat);
    }
    sortKey(fieldValue, _field) {
        if (!fieldValue) {
            return -1;
        }
        return fieldValue;
    }
    useSortCache() {
        return false;
    }
    useNaturalSorting(field, fieldValue, isGroupByRule) {
        return false;
    }
    groupByKey(fieldValue, field) {
        return this.sortKey(fieldValue, field);
    }
    filterValueToString(filterValue, field, userPreferences, _comparison) {
        return this.valueToString(filterValue, field, userPreferences);
    }
    getInlineEditRules(field) {
        const baseInlineEditRules = super.getInlineEditRules(field);
        return {
            ...baseInlineEditRules,
            saveKeys: types_1.navigationKeys,
            editorWidth: "100%",
        };
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            contentAlignment: "centered",
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison === "is_equal_to" && filterValue) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
}
exports.TimeFieldLogic = TimeFieldLogic;
